<template>
  <div :class="['form-item-box', { 'change-form-item-box-style': item.changeformItemBoxStyle }]">
    <div v-for="subitem in item.children" :key="subitem.field" class="form-item-content">
      <div class="form-item-label">
        <label :for="item.field" class="form-item-subTitle">{{ i18n.t(subitem.label) }}</label>
        <span v-if="subitem.subLabel" class="sub-label">{{ i18n.t(subitem.subLabel) }}</span>
      </div>
      <div class="input-wrapper">
        <input
          :id="subitem.field"
          :maxlength="subitem.maxlength"
          :minlength="subitem.minlength"
          :placeholder="subitem.placeholder"
          :class="['form-item-input', { 'form-item-error-border': subitem.errorShow }]"
          :disabled="subitem.disabled"
          :type="inputType(subitem)"
          aria-required="true"
          autocomplete="off"
          v-model="itemValue[subitem.field]"
          @blur="handleValueSend($event, subitem.field)"
          @change="handleValueChange($event, subitem.field)"
        />
        <img
          v-if="subitem.comeForm === 'SignUp2'"
          class="eye"
          :src="subitem.on ? eyeOn : eyeOff"
          @click="clickEye(subitem)"
          alt=""
        />
      </div>
      <p v-show="subitem.errorShow" class="form-item-error" :key="subitem.errorMsg">
        {{ subitem.errorMsg }}
      </p>
    </div>
  </div>
</template>

<script>
  import i18n from '@/i18n';

  export default {
    name: 'form-name-sign-up2',
    props: {
      item: {
        type: Object,
        default: () => {},
      },
      itemFormValue: {
        type: Object,
        default: () => {},
      },
    },

    // mounted() {
    //   if (this.itemFormValue) {
    //     const isItem = Object.keys(this.itemFormValue);
    //     if (isItem?.length) {
    //       this.itemValue = { ...this.itemValue, ...this.itemFormValue };
    //     }
    //   }
    //   this.itemValue.lname = this.itemValue.lname && showFirstChar(this.itemValue.lname)
    //   this.itemValue.fname = this.itemValue.fname && showFirstChar(this.itemValue.fname)
    //   this.changeName.lname = this.itemValue.lname && showFirstChar(this.itemValue.lname)
    //   this.changeName.fname = this.itemValue.lname && showFirstChar(this.itemValue.fname)
    // },

    data() {
      return {
        i18n,
        changeName: {
          lname: '',
          fname: '',
        },
        eyeOn: require('@/assets/images/icon-feather-eye-on.svg'),
        eyeOff: require('@/assets/images/icon-feather-eye-off.svg'),
        itemValue: {},
      };
    },

    methods: {
      inputType(item) {
        return item.inputType;
      },
      // 失去焦点后发送给父组件的数据
      handleValueSend(e, field) {
        this.$emit('value', this.itemValue, field);
      },
      handleValueChange(e, field) {
        this.$emit('value', this.itemValue, field);
      },
      clickEye(item) {
        item.on = !item.on;
        if (!item.on) {
          item.inputType = 'password';
        } else {
          item.inputType = 'text';
        }
        return this.itemFormValue && (this.itemValue[item.field] = this.itemFormValue[item.field]);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index';
  @import './mobile';
</style>
